import PropTypes from 'prop-types'
import { Fragment } from 'react'

import Pill from 'components/common/Pill'
import theme from 'theme'
import { pluralize } from 'utils/strings'

export function AdditionalTargets({ children }) {
  return (
    <Pill
      css={{
        alignSelf: 'flex-start'
      }}
      type="gray"
    >
      +{children}
    </Pill>
  )
}

AdditionalTargets.propTypes = {
  children: PropTypes.node
}

export function IlfiTargets({ targets }) {
  if (targets.length < 1) return null

  const firstTarget = targets[0]
  const additionalTargetsCount = targets.length - 1
  return (
    <Fragment>
      <Pill
        css={{
          marginLeft: theme.space[0],
          alignSelf: 'flex-start'
        }}
        tooltip={firstTarget}
      >
        {firstTarget}
      </Pill>
      {additionalTargetsCount > 0 && (
        <AdditionalTargets>{additionalTargetsCount}</AdditionalTargets>
      )}
    </Fragment>
  )
}

IlfiTargets.propTypes = {
  targets: PropTypes.array
}

export function KubernetesTargets({ targets }) {
  if (targets.length < 1) return null

  const [firstKind, ...list] = targets
  const additionalKindCounts = list.reduce((total, { count }) => {
    return total + count
  }, 0)
  return (
    <Fragment>
      <Pill
        css={{
          marginLeft: theme.space[0],
          textTransform: 'capitalize',
          overflow: 'visible'
        }}
      >
        {pluralize(firstKind.name.toLowerCase(), firstKind.count)}{' '}
        {firstKind.count}
      </Pill>
      {additionalKindCounts > 0 && (
        <AdditionalTargets>{additionalKindCounts}</AdditionalTargets>
      )}
    </Fragment>
  )
}

KubernetesTargets.propTypes = {
  targets: PropTypes.array
}
